import styled from 'styled-components';

export const TableTitle = styled.h2`
  border-bottom: 1px solid #F0F0F0;
  box-sizing: border-box;
  color: #333333;
  font-size: 24px;
  font-weight: bold;
  margin: 0 20px 20px 20px;
  padding: 20px 0 10px 0;
`;